// extracted by mini-css-extract-plugin
export var root = "project-preview-module--root--wfIAY";
export var title = "project-preview-module--title--04c-s typography-module--responsiveTitle1--0t0jA";
export var leadMediaThumb = "project-preview-module--leadMediaThumb---5Zp+";
export var excerpt = "project-preview-module--excerpt--chs3A";